jQuery(document).ready(function($) {

    $( ".bloc_arguments_grille" ).each(function( index ) {

        var parent = $(this).find(".arguments")
        var cibleArgs = parent.find(".argument")

        gsap.from( cibleArgs, {
            y : +400,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "top 30%",
                scrub: 1,
            }

        })


    })

});